import { useTranslation } from '@/hooks/useTranslation';
import { Hero } from '@/components/generic/Hero';
import { ReactNode } from 'react';

export const AdminHero = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();
  return <Hero title="Administration">{children}</Hero>;
};
